import request from '../services/request';

export function getProfile() {
  return request({
    url: `/profile`,
    method: 'GET',
  });
}

export function updateProfile(data) {
  return request({
    url: `/profile`,
    method: 'PUT',
    data,
  });
}

export function updatePassword(data) {
  return request({
    url: `/profile/password`,
    method: 'PUT',
    data,
  });
}

export function getAccess() {
  return request({
    url: `/profile/access`,
    method: 'GET',
  });
}

export function findNotifications() {
  return request({
    url: `/profile/notification`,
    method: 'GET',
  });
}

export function clickNotification(id, data) {
  return request({
    url: `/profile/notification/${id}/clicked`,
    method: 'PUT',
    data,
  });
}

export function destroyNotification(id) {
  return request({
    url: `/profile/notification/${id}`,
    method: 'DELETE',
  });
}

export function destroyAllNotifications() {
  return request({
    url: `/profile/notification/all`,
    method: 'DELETE',
  });
}

export function logoutProfile() {
  return request({
    url: `/profile/logout`,
    method: 'POST',
  });
}
